import {
    BACK_BUTTON_ROLE,
    DELIVERY_MODE,
    TCPOS,
    VALIDATE_BUTTON_ROLE,
} from "@constants";
import { useSnapshot } from "valtio";

import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { store } from "@store";

import { getImageContentById } from "@helpers/general";

import {
    checkVisibilityNewOrder,
    clearTCPOSOrder,
    deletedInvisibleNewOrder,
    editSalesMode,
} from "@components/OrderTaking/Helpers";
import { orderSalesModeModification } from "@components/OrderTaking/Store/feature";

import {
    kioskStore,
    setChosenInformationMode,
    setFinalMessageSelectedInformationMode,
    setIsInformationModesModalOpened,
    setIsUserAccountModalOpened,
    setSaleMode,
    setSelectedInformationMode,
    setSelectedSaleModeId,
    setSelectedSaleModeOrderTaking,
    setSelectedSaleModeValue,
} from "@pages/Kiosk/store";

export default function useSalesModesChangeConfirmationDialog(
    salesMode,
    onClose
) {
    const [isPatientModelOpen, setIsPatientModelOpen] = React.useState(false);
    const { orderItems, totalPrice } = useSelector(
        (state) => state.orderSlice.order
    );

    const dispatchStore = useDispatch();
    const {
        project: {
            template: {
                content: { actionsButtons, informationModes },
                pages: { ways },
            },
        },
        logo,
        selectedInformationMode,
        isUserAuthenticated,
        kioskWays,
        devise,
        isPrm,
    } = useSnapshot(kioskStore);

    const { posEditor } = useSnapshot(store);

    const { t } = useTranslation();

    const backButton = actionsButtons.items.filter((item) => {
        return item.role === BACK_BUTTON_ROLE;
    })[0];

    const backImageSrc = getImageContentById(backButton.id);
    const filteredButtons = actionsButtons.items.filter((item) => {
        return item.role === VALIDATE_BUTTON_ROLE;
    })[0];

    const validateImageSrc = getImageContentById(filteredButtons.id);
    const logoImageSrc = getImageContentById(logo.id);

    let order = JSON.parse(JSON.stringify(orderItems));
    const refactorOrder = () =>
        !(TCPOS === posEditor)
            ? checkVisibilityNewOrder(order, salesMode.settingKey)
            : orderItems;
    const deletedInvisibleOrder = () =>
        !(TCPOS === posEditor)
            ? deletedInvisibleNewOrder(newOrder, salesMode.settingKey)
            : orderItems;
    const editSalesModeNewOrder = () =>
        !(TCPOS === posEditor)
            ? editSalesMode(newModifiedOrder, salesMode.id)
            : orderItems;

    const [newOrder] = React.useState(refactorOrder());
    const [newModifiedOrder] = React.useState(deletedInvisibleOrder());
    const [newOrderItems] = React.useState(editSalesModeNewOrder());

    const handleModificationSalesMode = () => {
        setSaleMode(salesMode);
        if (TCPOS === posEditor) {
            setIsPatientModelOpen(true);
            setSelectedSaleModeValue(salesMode.name);
            setSelectedSaleModeId(salesMode.id);
            setSelectedSaleModeOrderTaking(salesMode.settingKey);
            dispatchStore(clearTCPOSOrder(salesMode));
        }

        if (
            salesMode.name !== DELIVERY_MODE ||
            (salesMode.name === DELIVERY_MODE && isUserAuthenticated === true)
        ) {
            setSelectedSaleModeValue(salesMode.name);
            setSelectedSaleModeId(salesMode.id);
            setSelectedSaleModeOrderTaking(salesMode.settingKey);

            dispatchStore(orderSalesModeModification(newOrderItems));
        }

        const activesInformationModes = informationModes.items.filter(
            (item) => item.active[salesMode.name]
        );
        const orderTakingStepIndex = kioskWays.indexOf(
            kioskWays.filter((page) => page?.name === "orderTaking")[0]
        );
        const informationModesStepIndex = kioskWays.indexOf(
            kioskWays.filter((page) => page?.name === "informationModes")[0]
        );

        if (
            (activesInformationModes.filter(
                (infoMode) => infoMode.shortName === selectedInformationMode
            ).length === 0 ||
                activesInformationModes.length > 1) &&
            ways.informationModes !== undefined &&
            orderTakingStepIndex > informationModesStepIndex
        ) {
            if (activesInformationModes.length === 0) {
                setFinalMessageSelectedInformationMode("none");
                setSelectedInformationMode("");
                setChosenInformationMode({
                    type: "",
                    data: { infoModeUuId: "", value: "" },
                });
                if (!isUserAuthenticated) setIsUserAccountModalOpened(true);
            } else {
                setIsInformationModesModalOpened(true);
            }
        } else if (
            salesMode.name === DELIVERY_MODE &&
            isUserAuthenticated === false &&
            ((ways.informationModes !== undefined &&
                ((activesInformationModes.filter(
                    (infoMode) => infoMode.shortName === selectedInformationMode
                ).length !== 0 &&
                    orderTakingStepIndex > informationModesStepIndex) ||
                    orderTakingStepIndex < informationModesStepIndex)) ||
                ways.informationModes === undefined)
        ) {
            setIsUserAccountModalOpened(true);
        }

        onClose();
    };
    return {
        t,
        handleModificationSalesMode,
        setIsPatientModelOpen,
        validateImageSrc,
        backImageSrc,
        logoImageSrc,
        devise,
        isPatientModelOpen,
        totalPrice,
        isPrm,
        actionsButtons,
        posEditor,
        orderItems,
        newOrderItems,
        newOrder,
    };
}
